export default "__VITE_ASSET__7c95286f__$_?component__"